import { t } from '@lingui/core/macro'
import React from 'react'
import { Accordion, Divider } from '@tecsinapse/cortex-react'
import { TriggerAccordion } from './trigger-accordion'
import { useSetores } from '@/modules/dealer-edicao/hooks/use-setores'
import { FormMultiGroupedSelect } from '../../hook-form-connectors/form-multi-grouped-select'

interface AccordionSetoresProps {
  possuiSetores?: boolean
}

export const AccordionSetores = ({ possuiSetores }: AccordionSetoresProps) => {
  const { setoresByDivisaoMapOptions } = useSetores()

  return setoresByDivisaoMapOptions && setoresByDivisaoMapOptions?.size > 0 ? (
    <div className={'mt-deca border border-secondary-light rounded-mili '}>
      <Accordion.Face direction={'vertical'}>
        <TriggerAccordion
          labelCheboxbox={t`Por setor`}
          idCheckbox={'possuiSetores'}
          value={possuiSetores}
          fieldToClear={'setores'}
        />
        <Accordion.Content direction={'vertical'}>
          <Divider />
          <div className={'p-deca h-[15rem]'}>
            <div className={'sm:w-[50%]'}>
              <FormMultiGroupedSelect
                name='setores'
                options={setoresByDivisaoMapOptions}
                groupedLabelExtractor={(label: string) =>
                  `${t`Divisão`} ${label}`
                }
                className='col-span-1'
                label={t`Setores`}
                withSearch
              />
            </div>
          </div>
        </Accordion.Content>
      </Accordion.Face>
    </div>
  ) : null
}
